import { Box, Stack } from "@mui/material"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import Iconify from "minimals-template/components/Iconify"
import { AddAssetRegister } from "./add-asset-register"

export function RegisterToolbar() {
    return (
        <Box py={2}>
            <Stack spacing={2} sx={{ "& *": { fontSize: 14 } }}>
                <Box>
                    <AddAssetRegister />
                </Box>
                <SearchBoxUsingSearchParam
                    placeholder="Search by name, regime or status..."
                    variant="outlined"
                    startAdornment={<Iconify icon="iconamoon:search" width="24px" height="24px" />}
                    sx={{ width: 1, py: 0, "& *": { fontSize: 14 } }}
                    textFieldProps={{ inputProps: { sx: { py: 1, borderRadius: 1 } } }}
                    aria-label="Search bar for registers"
                />
            </Stack>
        </Box>
    )
}
